/**
 * WordPress dependencies
 */
import domReady from '@safe-wordpress/dom-ready';

/**
 * Internal dependencies
 */
import './style.scss';
import { markTestPreviewAsActive } from '../utils';
import { appendStyle } from '../../../../../../assets/src/public/utils/helpers/append-style';
import { elementReady } from '../../../../../../assets/src/public/utils/helpers/element-ready';
import type { ScriptAlternative } from '../../../../../../assets/src/public/types';

export function initJavaScriptPreviewer(
	alternative: {
		readonly run: string;
	},
	enabled: boolean
): void {
	markTestPreviewAsActive( enabled );
	if ( enabled ) {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, no-eval
		const run: ScriptAlternative[ 'run' ] = eval(
			`(()=>${ alternative.run })()`
		);
		run( () => void null, {
			appendStyle,
			domReady,
			elementReady,
			showContent: () => void null,
		} );
	}
}
